<template>

	<button type="button" class="button solid black small" :style="'--accent:' + this.accent" v-on:click="toggleQuestions()">
		<span class="fa-stack fa-1x">
			<i class="fal fa-circle fa-stack-2x"></i>
			<i class="fas fa-question fa-stack-1x"></i>
		</span>
		Complete
	</button>

</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'accent'
	],

	data: () => {
		return {
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		toggleQuestions: function () {
			this.$root.$refs.questions.toggleQuestions();
		}

	}
};
</script>